<div class="order-template">
  <div class="d-md-flex justify-content-between align-items-center">
    <div class="custom-order-template-title">
      <h1>
        {{ 'account.ordertemplates.heading' | translate }}
      </h1>
    </div>
    <div class="custom-order-tempate-link">
      <a
        [routerLink]="[]"
        class="order-template-link btn btn-primary btn-lg"
        data-testing-id="add-order-template"
        (click)="addOrderTemplateDialog.show()"
        >{{ 'account.order_template.list.button.add_template.label' | translate }}</a
      >
    </div>
  </div>

  <!-- Error message -->
  <ish-error-message [error]="orderTemplateError$ | async" />

  <ish-account-order-template-list [orderTemplates]="orderTemplates$ | async" />
</div>

<ish-order-template-preferences-dialog #addOrderTemplateDialog (submitOrderTemplate)="addOrderTemplate($event)" />

<ish-loading *ngIf="orderTemplateLoading$ | async" />
